import { ChangeDetectionStrategy, Component } from "@angular/core";
import { BulkUploadLayoutComponent } from "@m19-board/bulk-upload/bulk-upload-layout/bulk-upload-layout.component";
import { provideBulkUpload } from "@m19-board/services/bulk-upload/bulk-upload.tokens";
import { PromoBoostBulkUploadHandler } from "@m19-board/services/bulk-upload/promo-boost/promo-boost-bulk-upload-handler.service";

@Component({
  selector: "app-promo-boost-bulk-upload-page",
  imports: [BulkUploadLayoutComponent],
  providers: [provideBulkUpload(PromoBoostBulkUploadHandler)],
  template: `<app-bulk-upload-layout />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromoBoostBulkUploadPageComponent {}
